/**
 * @generated SignedSource<<6d41eafa00a16c051e7c55f81156f447>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "DeleteMyAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "toDeleteAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileDeleteMyAccountScreenDeleteMutation",
    "selections": (v0/*: any*/),
    "type": "ClientAppMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileDeleteMyAccountScreenDeleteMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "6b91c508723fba532b8de3dae6987999",
    "id": null,
    "metadata": {},
    "name": "ProfileDeleteMyAccountScreenDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ProfileDeleteMyAccountScreenDeleteMutation {\n  DeleteMyAccount {\n    id\n    toDeleteAt\n  }\n}\n"
  }
};
})();

node.hash = "d1ca359c70511f3ec8a5cebfb1e4d418";

module.exports = node;
